__turbopack_context__.v({
  "button": "PlasmicNews-module__g4gLLq__button",
  "content2": "PlasmicNews-module__g4gLLq__content2",
  "freeBox": "PlasmicNews-module__g4gLLq__freeBox",
  "img": "PlasmicNews-module__g4gLLq__img",
  "link": "PlasmicNews-module__g4gLLq__link",
  "news": "PlasmicNews-module__g4gLLq__news",
  "newsDivider": "PlasmicNews-module__g4gLLq__newsDivider",
  "newsExcerpts": "PlasmicNews-module__g4gLLq__newsExcerpts",
  "newsItem": "PlasmicNews-module__g4gLLq__newsItem",
  "newsItemPlaceholder": "PlasmicNews-module__g4gLLq__newsItemPlaceholder",
  "newsProvider": "PlasmicNews-module__g4gLLq__newsProvider",
  "svg__ctYXi": "PlasmicNews-module__g4gLLq__svg__ctYXi",
  "svg__eWp0J": "PlasmicNews-module__g4gLLq__svg__eWp0J",
  "title": "PlasmicNews-module__g4gLLq__title",
});
